import React, { useRef, useState, useEffect } from "react";
import { Grid } from "@mui/material";
import "./addReport.scss";
import SwCommonForm from "./addReport/swCommonForm";
import Buttons from "../../../../library/custom/button/Button";
import SwIndividualCommonForm from "./addReport/swIndividualCommonForm";
import NorthCarolina from "./addReport/northCarolina";
import DayRainfall from "./addReport/dayRainfall";
import CurrentPhaseProject from "./addReport/currentPhaseProject";
import SiteCompliance from "./addReport/siteCompliance";
import TopTwoQuestion from "./addReport/topTwoQuestion";
import CategoryAccordion from "./addReport/categoryAccordion";
import SignoffMethod from "./addReport/SignoffMethod";
import BackBtn from "../../../../library/custom/backBtn/backBtn";
import { YES_NO } from "../../../../constant/constant";
import SelectMenu from "../../../../library/custom/selectMenu/SelectMenu";
import FormLabels from "../../../../library/custom/formLabel/FormLabels";
import FormControl from "@mui/material/FormControl";

const AddReport = (props) => {
  const [frequency, setFrequency] = useState();

  // temporary base change
  const [InspectionType, setInspectionType] = useState();

  useEffect(() => {
    const { isGeorgiaState, getSwReference } = props;

    if (getSwReference) {
      if (isGeorgiaState && getSwReference?.insfrequencyList) {
        const newFrequency = getSwReference?.insfrequencyList?.filter(
          (item) => item.key !== 1,
        );
        setFrequency(newFrequency);

        // temporary base change
        const newInspectionType = getSwReference?.insTypeMstList?.filter(
          (item) => item.key !== 2,
        );
        setInspectionType(newInspectionType);

        return;
      }

      // if (
      //   props?.getSwProjectDetailData?.data?.result?.stateId === 42 &&
      //   getSwReference?.insTypeMstList
      // ) {
      //   setFrequency(getSwReference?.insfrequencyList);
      //   const newInspectionType = getSwReference?.insTypeMstList?.filter(
      //     (item) => item.key !== 3,
      //   );
      //   setInspectionType(newInspectionType);

      //   return;
      // }

      setFrequency(getSwReference?.insfrequencyList);
      setInspectionType(getSwReference?.insTypeMstList);
    }
  }, [
    props?.isGeorgiaState,
    props?.getSwProjectDetailData,
    props?.getSwReference?.insfrequencyList,
    props?.getSwReference?.insTypeMstList,
  ]);

  useEffect(() => {
    if (props?.isFluid && props?.getSwReference?.insfrequencyList) {
      const data = props?.getSwReference?.insfrequencyList?.filter(
        (item) => item.key !== 1,
      );
      setFrequency(data);
    } else {
      const data = props?.getSwReference?.insfrequencyList?.filter(
        (item) => item.key !== 7,
      );
      setFrequency(data);
    }
  }, [props?.isFluid, props?.getSwReference?.insfrequencyList]);

  const dataBack = {
    title: "Back",
    route: -1,
  };

  return (
    <div className="swAddReport">
      <Grid container className="formController" mt={5}>
        <Grid container item md={9} xs={12} spacing={2}>
          {!props?.mapId && (
            <SwIndividualCommonForm
              propsData={props}
              frequency={frequency}
              InspectionType={InspectionType}
            />
          )}

          {props?.questionSetId && props?.swQuestionSetDetail && (
            <>
              <SwCommonForm
                propsData={props}
                frequency={frequency}
                InspectionType={InspectionType}
                fetchRainfallData={props.fetchRainfallData}
              />
            </>
          )}
        </Grid>
      </Grid>

      {props?.questionSetId && props?.swQuestionSetDetail && (
        <>
          {(props?.isNorthCarolina || props?.isSouthCarolina) && (
            <>
              <DayRainfall
                swRainFallData={props?.swRainFallData}
                swInspectionRainfallData={props?.swInspectionRainfallData}
                primaryInspector={props?.formValue?.primaryInspector}
                setSwInspectionRainfallData={props?.setSwInspectionRainfallData}
              />
              <CurrentPhaseProject
                swInspectionCurrentProjectPhase={
                  props?.swInspectionCurrentProjectPhase
                }
                setSwInspectionCurrentProjectPhase={
                  props?.setSwInspectionCurrentProjectPhase
                }
                projectPhaseError={props?.projectPhaseError}
              />

              <TopTwoQuestion
                swInspectionConfQuestionAns={props?.swInspectionConfQuestionAns}
                setSwInspectionConfQuestionAns={
                  props?.setSwInspectionConfQuestionAns
                }
                getSwReference={props?.getSwReference}
                twoQuestionError={props?.twoQuestionError}
                isNorthCarolina={props?.isNorthCarolina}
              />
            </>
          )}

          {props?.isTennessee && (
            <>
              <SiteCompliance
                setSwInspectionSiteCompliance={
                  props?.setSwInspectionSiteCompliance
                }
                swInspectionSiteCompliance={props?.swInspectionSiteCompliance}
                siteComplianceError={props?.siteComplianceError}
              />

              <div className="twoQuestionList">
                <Grid container>
                <Grid item lg={7} md={7} sm={7} xs={12} mb={2}>
                  <FormControl fullWidth>
                    <FormLabels
                      label={
                        "Are all applicable EPSCs installed and maintained per the SWPPP per the current phase?"
                      }
                      isRequired={false}
                    />
                    <SelectMenu
                      placeholder="Please Select"
                      listData={YES_NO ?? []}
                      value={props?.epscInstalled ?? ""}
                      onchangehandler={props?.twoQuesInstalledHandler}
                    />
                  </FormControl>
                </Grid>

                <Grid item lg={7} md={7} sm={7} xs={12}>
                  <FormControl fullWidth>
                    <FormLabels
                      label={
                        "Are EPSCs functioning correctly at all disturbed areas/material storage areas?"
                      }
                      isRequired={false}
                    />
                    <SelectMenu
                      placeholder="Please Select"
                      listData={YES_NO ?? []}
                      value={props?.epscFunctioning ?? ""}
                      onchangehandler={props?.twoQuesFunctioningHandler}
                    />
                  </FormControl>
                </Grid>
                </Grid>
              </div>
            </>
          )}

          <CategoryAccordion propsData={props} />

          {(props?.isNorthCarolina || props?.isSouthCarolina) && (
            <Grid container>
              <NorthCarolina propsData={props} />
            </Grid>
          )}

          <SignoffMethod propsData={props} />

          <Grid container mt={7} className="buttonEnd">
            <Grid className="backBtnPosition">
              <BackBtn dataBack={dataBack} />
            </Grid>
            <Grid item lg={4} xs={12} sm={6} md={6}>
              <Buttons
                varientText={true}
                label="Save As Draft"
                onClick={props?.saveData}
              />
            </Grid>
            <Grid item lg={4} xs={12} sm={6} md={6}>
              <Buttons
                varientContained={true}
                label={"Save"}
                onClick={props?.submitData}
              />
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
};

export default AddReport;
